import React from 'react';
import { createRoot /* ,hydrateRoot */} from 'react-dom/client';
import './index.css';
import App from './main/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from "react-router-dom";
import IntlProviderConfigured from './_i18n/IntlProviderConfigured';


// Auto-recovery from stale Webpack chunks after a new deployment:
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (event.message && /Loading chunk [\w-]+ failed|ChunkLoadError/i.test(event.message)) {
      const retryKey = 'chunk_reload_attempt';
      if (!sessionStorage.getItem(retryKey)) {
        sessionStorage.setItem(retryKey, '1');
        window.location.reload();
      }
    }
  });

  window.addEventListener('load', () => {
    sessionStorage.removeItem('chunk_reload_attempt');
  });
}

class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof console !== 'undefined') {
      console.error('AppErrorBoundary caught an error:', error, errorInfo);
    }
    if (error && /Loading chunk|ChunkLoadError/i.test(error.message)) {
      const retryKey = 'chunk_reload_attempt';
      if (!sessionStorage.getItem(retryKey)) {
        sessionStorage.setItem(retryKey, '1');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2>Online-Timer</h2>
          <p>Uma nova versão foi disponibilizada ou ocorreu um problema de carregamento.</p>
          <button
            onClick={() => {
              sessionStorage.removeItem('chunk_reload_attempt');
              window.location.reload();
            }}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Atualizar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const domNode = document.getElementById('root');
const reactNode = (
  <AppErrorBoundary>
    <IntlProviderConfigured>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IntlProviderConfigured>
  </AppErrorBoundary>
);

createRoot(domNode).render(reactNode);

serviceWorkerRegistration.register();
